import {
  trackEvent,
  setUserId,
  setUserProfile,
  trackFormInput,
  aliasUser,
} from "@/services/mixpanel";

const useMixpanel = () => {
  return { trackEvent, setUserId, setUserProfile, trackFormInput, aliasUser };
};

export { useMixpanel };
